/**
 * Tracks changes made from this tab so their server echo (e.g. job.worker.added) does not raise
 * a second toast/flash/announcement on top of the one the action already showed.
 */
export type LocalMutationKind = 'add' | 'remove' | 'remind' | 'required'

const pending = new Map<string, number>()
const TTL_MS = 60_000

const keyOf = (kind: LocalMutationKind, jobId: string, workerId = '') => `${kind}|${jobId}|${workerId}`

export function registerLocalMutation(kind: LocalMutationKind, jobId: string, workerId?: string) {
  pending.set(keyOf(kind, jobId, workerId), Date.now() + TTL_MS)
}

/** Returns true (and forgets it) when the event is the echo of a local change. */
export function consumeLocalMutation(kind: LocalMutationKind, jobId: string, workerId?: string): boolean {
  const key = keyOf(kind, jobId, workerId)
  const expiresAt = pending.get(key)
  if (expiresAt == null) return false
  pending.delete(key)
  return expiresAt > Date.now()
}

export function clearLocalMutation(kind: LocalMutationKind, jobId: string, workerId?: string) {
  pending.delete(keyOf(kind, jobId, workerId))
}
